import React from 'react';
import classnames from 'classnames';
import { ListerProductData } from '../../../../../../types';
import descriptionStyles from './description.module.pcss';

interface DescriptionProps {
  product: ListerProductData;
}

function Description({ product: { manufacturer, name, modelCase } }: DescriptionProps): React.ReactElement {
  return (
    <div className={classnames(descriptionStyles.description)}>
      <h4 className={classnames('rolex-subtitle')} itemProp="brand">
        {manufacturer}
      </h4>
      <h5 className={classnames(['rolex-title', 'rolex-title--sm'])} itemProp="name">
        {name}
      </h5>
      <h6 className={classnames(['rolex-description', 'rolex-description--sm'])} itemProp="description">
        {modelCase}
      </h6>
    </div>
  );
}

export default Description;
